import { useEffect } from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import ApolloProvider from "./ApolloProvider";

type Theme = "dark" | "light";

const getTheme = (theme?: unknown): Theme => (theme === "dark" ? "dark" : "light");

const applyTheme = (theme: Theme) => {
  const body = document.body;
  const html = document.documentElement;

  body.classList.remove("dark-theme", "light-theme");
  html.classList.remove("dark-theme", "light-theme");
  html.style.colorScheme = theme;

  if (theme === "dark") {
    body.classList.add("dark-theme");
    html.classList.add("dark-theme");
    body.style.backgroundColor = "#1e1e1e";
    body.style.color = "#e0e0e0";
    html.style.backgroundColor = "#1e1e1e";
  } else {
    body.classList.add("light-theme");
    html.classList.add("light-theme");
    body.style.backgroundColor = "#ffffff";
    body.style.color = "#212121";
    html.style.backgroundColor = "#ffffff";
  }
};

const ThemeProvider = () => {
  useEffect(() => {
    const handleThemeMessage = (event: MessageEvent) => {
      if (event.data?.info === "updateTheme") {
        const theme = getTheme(event.data.theme);
        applyTheme(theme);
        localStorage.setItem("theme", theme);
      }

      if (event.data?.info === "clearTheme") {
        localStorage.removeItem("theme");
        applyTheme("light");
      }
    };

    window.addEventListener("message", handleThemeMessage);

    applyTheme(getTheme(localStorage.getItem("theme")));

    return () => {
      window.removeEventListener("message", handleThemeMessage);
    };
  }, []);

  return ApolloProvider;
};

ReactDOM.render(<ThemeProvider />, document.getElementById("root"));


reportWebVitals();
